import { useEffect, useState } from "react";
import { IBaseDocumentItemKizDTO } from "../../libs/coreapi-dto/documents/base"
import { useAppContext } from "../providers/appContextProvider";
import { SysOptionsDataProvider } from "../../Services/DataProviders/SysOptionsDataProvider";
import { SysOptionName } from "../../@types/enumsGlobal";

export const useAutoSaveDocument = (items: IBaseDocumentItemKizDTO[], saveDocument: () => void) => {
    const interval = 300 * 1000
    const appContext = useAppContext();
    const sysOptionsDataProvider = new SysOptionsDataProvider(appContext.coreApiService)
    const [isAutoSave,setIsAutoSave] = useState<boolean>(false)
    const [countTimer, setCountTimer] = useState(0);

    useEffect(() => {
          sysOptionsDataProvider.getByName(SysOptionName.AutoSaveDocument, (data) => {
            setIsAutoSave(data?.value.toLowerCase() === 'true')
          })
    },[])

    useEffect(() => {
        const timer = setInterval(() => {
          if (items && items.length >= 10 && isAutoSave) {
            saveDocument()
            setCountTimer(countTimer + 1)
          }
        }, interval);
        
        return () => clearInterval(timer);
    },[countTimer, isAutoSave,items]);
}

export default useAutoSaveDocument